import * as types from '../types';

const initialState = {
  properties: [],
  propertiesCount: 0,
  filter: {
    from: '',
    length: '',
    sort: '',
    region: '',
    transactionType: '',
    advisorName: '',
    propertyCode: '',
    propertyType: '',
    bedrooms: '',
    bedroomExactly: '',
    foundationFrom: '',
    foundationTo: '',
    areaFrom: '',
    areaTo: '',
    overallPriceFrom: '',
    overallPriceTo: '',
    segmentPriceFrom: '',
    segmentPriceTo: '',
    facilities: '',
    parkingSpace: '',
    parkingSpaceExactly: '',
    totalFloors: '',
    totalFloorsExactly: '',
    propertyFloorFrom: '',
    propertyFloorTo: '',
    totalUnitsPerFloor: '',
    totalUnitsPerFloorExactly: '',
    propertyUnit: '',
    propertyUnitExactly: '',
    balcony: '',
    cabinet: '',
    flooring: '',
    wareHouse: '',
    propertyDirection: '',
    picture: ''
  },
  selectedProperty: null,
  loading: {
    list: false,
    detail: false
  },
  advisorProperties: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PROPERTY_SET_LIST:
      return {...state, properties: action.data};
    case types.PROPERTY_SET_COUNT:
      return {...state, propertiesCount: action.data};
    case types.PROPERTY_SET_FILTER:
      return {...state, filter: {...initialState.filter, ...action.data}};
    case types.PROPERTY_SET_FROM_FILTER:
      return {...state, filter: {...state.filter, from: action.data}};
    case types.PROPERTY_SET_LENGTH_FILTER:
      return {...state, filter: {...state.filter, from:0, length: action.data}};
    case types.PROPERTY_SET_SORT_FILTER:
      return {...state, filter: {...state.filter, sort: action.data}};
    case types.PROPERTY_SET_REGION_FILTER:
      return {...state, filter: {...state.filter, from:0, region: action.data}};
    case types.PROPERTY_SET_TRANSACTION_TYPE_FILTER:
      return {...state, filter: {...state.filter, from:0, transactionType: action.data}};
    case types.PROPERTY_SET_ADVISOR_NAME_FILTER:
      return {...state, filter: {...state.filter, from:0, advisorName: action.data}};
    case types.PROPERTY_SET_PROPERTY_CODE_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyCode: action.data}};
    case types.PROPERTY_SET_PROPERTY_TYPE_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyType: action.data}};
    case types.PROPERTY_SET_BEDROOMS_FILTER:
      return {...state, filter: {...state.filter, from:0, bedrooms: action.data}};
    case types.PROPERTY_SET_BEDROOMS_EXACTLY_FILTER:
      return {...state, filter: {...state.filter, from:0, bedroomExactly: action.data}};
    case types.PROPERTY_SET_FOUNDATION_FROM_FILTER:
      return {...state, filter: {...state.filter, from:0, foundationFrom: action.data}};
    case types.PROPERTY_SET_FOUNDATION_TO_FILTER:
      return {...state, filter: {...state.filter, from:0, foundationTo: action.data}};
    case types.PROPERTY_SET_AREA_FROM_FILTER:
      return {...state, filter: {...state.filter, from:0, areaFrom: action.data}};
    case types.PROPERTY_SET_AREA_TO_FILTER:
      return {...state, filter: {...state.filter, from:0, areaTo: action.data}};
    case types.PROPERTY_SET_OVERALL_PRICE_FROM_FILTER:
      return {...state, filter: {...state.filter, from:0, overallPriceFrom: action.data}};
    case types.PROPERTY_SET_OVERALL_PRICE_TO_FILTER:
      return {...state, filter: {...state.filter, from:0, overallPriceTo: action.data}};
    case types.PROPERTY_SET_SEGMENT_PRICE_FROM_FILTER:
      return {...state, filter: {...state.filter, from:0, segmentPriceFrom: action.data}};
    case types.PROPERTY_SET_SEGMENT_PRICE_TO_FILTER:
      return {...state, filter: {...state.filter, from:0, segmentPriceTo: action.data}};
    case types.PROPERTY_SET_FACILITIES_FILTER:
      return {...state, filter: {...state.filter, from:0, facilities: action.data}};
    case types.PROPERTY_SET_PARKING_SPACE_FILTER:
      return {...state, filter: {...state.filter, from:0, parkingSpace: action.data}};
    case types.PROPERTY_SET_PARKING_SPACE_EXACTLY_FILTER:
      return {...state, filter: {...state.filter, from:0, parkingSpaceExactly: action.data}};
    case types.PROPERTY_SET_TOTAL_FLOORS_FILTER:
      return {...state, filter: {...state.filter, from:0, totalFloors: action.data}};
    case types.PROPERTY_SET_TOTAL_FLOORS_EXACTLY_FILTER:
      return {...state, filter: {...state.filter, from:0, totalFloorsExactly: action.data}};
    case types.PROPERTY_SET_PROPERTY_FLOORS_FROM_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyFloorFrom: action.data}};
    case types.PROPERTY_SET_PROPERTY_FLOORS_TO_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyFloorTo: action.data}};
    case types.PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_FILTER:
      return {...state, filter: {...state.filter, from:0, totalUnitsPerFloor: action.data}};
    case types.PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_EXACTLY_FILTER:
      return {...state, filter: {...state.filter, from:0, totalUnitsPerFloorExactly: action.data}};
    case types.PROPERTY_SET_PROPERTY_UNIT_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyUnit: action.data}};
    case types.PROPERTY_SET_PROPERTY_UNIT_EXACTLY_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyUnitExactly: action.data}};
    case types.PROPERTY_SET_BALCONY_FILTER:
      return {...state, filter: {...state.filter, from:0, balcony: action.data}};
    case types.PROPERTY_SET_CABINET_FILTER:
      return {...state, filter: {...state.filter, from:0, cabinet: action.data}};
    case types.PROPERTY_SET_FLOORING_FILTER:
      return {...state, filter: {...state.filter, from:0, flooring: action.data}};
    case types.PROPERTY_SET_WARE_HOUSE_FILTER:
      return {...state, filter: {...state.filter, from:0, wareHouse: action.data}};
    case types.PROPERTY_SET_PROPERTY_DIRECTION_FILTER:
      return {...state, filter: {...state.filter, from:0, propertyDirection: action.data}};
    case types.PROPERTY_SET_PICTURE_FILTER:
      return {...state, filter: {...state.filter, from:0, picture: action.data}};
    case types.PROPERTY_SET_SELECTED_PROPERTY:
      return {...state, selectedProperty: action.data};
    case types.PROPERTY_SET_LIST_LOADING:
      return {...state, loading: {...state.loading, list: action.data}};
    case types.PROPERTY_SET_DETAIL_LOADING:
      return {...state, loading: {...state.loading, detail: action.data}};
    case types.PROPERTY_SET_LIST_ADVISOR_PROPERTIES:
      return {...state, advisorProperties: action.data};
    default:
      return state;
  }
}

